import React from 'react';
import '../styles/HistogramWidget.css'; // We'll create this file later

const HistogramStats = ({ 
    stats, 
    title, 
    valueFormatter = (value) => value, // Default formatter
    showAverage = true,
    showRange = true,
    showSampleSize = true,
    avgLabel = 'Avg',
    rangeLabel = 'Range',
    sampleLabel = 'Sample',
    avgColor = null // Optional color for average value
}) => {
    if (!stats) return null;

    // Format values safely
    const formattedAvg = stats.avg !== undefined && stats.avg !== null ? valueFormatter(stats.avg) : 'N/A';
    const formattedMin = stats.min !== undefined && stats.min !== null ? valueFormatter(stats.min) : 'N/A';
    const formattedMax = stats.max !== undefined && stats.max !== null ? valueFormatter(stats.max) : 'N/A';
    const formattedCount = stats.count !== undefined && stats.count !== null ? `${stats.count} posts` : 'N/A';

    return (
        <div className="histogram-stats-container">
            {title && <h3 className="histogram-stats-title">{title}</h3>}
            <div className="stats-grid">
                {showAverage && (
                    <div className="stat-item">
                        <span className="stat-label">{avgLabel}:</span>
                        <span className="stat-value" style={avgColor ? { color: avgColor } : {}}>{formattedAvg}</span>
                    </div>
                )}
                {showRange && (
                    <div className="stat-item">
                        <span className="stat-label">{rangeLabel}:</span>
                        <span className="stat-value">{formattedMin} - {formattedMax}</span>
                    </div>
                )}
                {showSampleSize && (
                    <div className="stat-item">
                        <span className="stat-label">{sampleLabel}:</span>
                        <span className="stat-value">{formattedCount}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default HistogramStats; 